import momentJalaali from 'moment-jalaali'
import React, { useEffect, useState } from 'react'

import { DateObject } from '../../../helpers/date'
import { AddCreditorsRequestInput } from '../../../types/walletCreditor'
import {
  Assignment,
  PaymentTermAssignmentRow
} from '../../../types/walletPaymentTerm'
import { PaymentTermAssignmentTable } from '../PaymentTermAssignmentTable'

interface StepThreePaymentTermAssignmentProps {
  creditorsInput: AddCreditorsRequestInput
  setcreditorsInput: React.Dispatch<
    React.SetStateAction<AddCreditorsRequestInput>
  >
  coveringRange: DateObject
  setcoveringRange: React.Dispatch<React.SetStateAction<DateObject>>
  sethasFinishedAssigning: React.Dispatch<React.SetStateAction<boolean>>
}
const StepThreePaymentTermAssignment: React.FC<
  StepThreePaymentTermAssignmentProps
> = ({
  creditorsInput,
  coveringRange,
  setcoveringRange,
  setcreditorsInput,
  sethasFinishedAssigning
}) => {
  const [assignment, setassignment] = useState<PaymentTermAssignmentRow[]>()
  useEffect(() => {
    setassignment(
      creditorsInput.creditors.map(
        (creditor, index) =>
          ({
            assignments: creditor.paymentTermAssignment.map((as) => ({
              assignmentTimeRange: {
                from: as.assignmentRange.from,
                to: as.assignmentRange.to
              },
              paymentTermID: as.paymentTermID,
              paymentTermCode: as.paymentTermCode,
              displayPaymentTermCode: as.displayPaymentTermCode,
              paymentTermName: as.paymentTermName
            })),
            entity: {
              entityCode: creditor.entity.entityCode,
              entityID: creditor.entity.entityID,
              entityName: creditor.entity.entityName,
              entityType: creditor.entity.entityType
            },
            id: String(index)
          } as PaymentTermAssignmentRow)
      )
    )
  }, [])
  useEffect(() => {
    setcreditorsInput((prev) => ({
      ...prev,
      creditors:
        prev.creditors?.map((creditor) => {
          // Find the corresponding assignment for this creditor
          const relevantAssignment = assignment?.find(
            (as) => as.entity.entityID === creditor.entity.entityID
          )

          return {
            ...creditor, // Retain existing creditor data
            paymentTermAssignment: relevantAssignment
              ? relevantAssignment.assignments.map((ass: Assignment) => ({
                  walletID: prev.walletID,
                  assignmentRange: {
                    from: ass.assignmentTimeRange.from,
                    to: ass.assignmentTimeRange.to
                  },
                  paymentTermID: ass.paymentTermID,
                  paymentTermCode: ass.paymentTermCode,
                  paymentTermName: ass.paymentTermName
                }))
              : creditor.paymentTermAssignment // Keep previous assignment if no match
          }
        }) || []
    }))
    const allAssignmentsFinished =
      assignment &&
      assignment.length > 0 &&
      assignment?.every((as) => {
        const lastAssignmentEnd = as.assignments
          .map((assn) =>
            momentJalaali(assn.assignmentTimeRange.to, 'YYYY-MM-DD')
          )
          .reduce(
            (max, date) => (date.isAfter(max) ? date : max),
            momentJalaali(0)
          )

        return (
          lastAssignmentEnd?.format('YYYY-MM-DD') ===
          coveringRange.gregorianEndDate
        )
      })
    sethasFinishedAssigning(allAssignmentsFinished || false)
  }, [assignment])

  return (
    <div>
      <PaymentTermAssignmentTable
        assignments={assignment || []}
        setassignments={setassignment}
        coveringRange={coveringRange}
        setcoveringRange={setcoveringRange}
      />
    </div>
  )
}

export default StepThreePaymentTermAssignment
